import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=1f3bd52c&scoped=true&"
import script from "./forgot.vue?vue&type=script&lang=js&"
export * from "./forgot.vue?vue&type=script&lang=js&"
import style0 from "./forgot.vue?vue&type=style&index=0&id=1f3bd52c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3bd52c",
  null
  
)

export default component.exports